import { getBaseURLAvartar  } from '@/utils.js'

export default {
    methods:{
        buildFullImageUrl_FromIDLABAndPath(_idlab,_path){
            return  `${getBaseURLAvartar()}/${_idlab}/${_path}`
        }
    }

}